<div style="background-color: #f8f4f4; width: 100%">
  <!-- Measurements Section -->
  <div
    class="p-4"
    style="margin-bottom: 40px; background-color: white; width: 100%"
  >
    <h1 class="text-center">Measurements</h1>
    <p class="text-center">
      {{ text }}
    </p>
    <div style="display: flex; justify-content: center; gap: 20px">
      <a
        [href]="getDownloadGuidlinesUrl()"
        target="_blank"
        type="button"
        class="j7 j8 an j9 ja bn fj fk fv fw fl fm am e8 b3 e6 bt bu jb jc ju je q r s ds bw cv by cx c2"
        style="
          font-size: 18px;
          border: 1px solid #00b4e6;
          color: #00b4e6;
          background-color: white;
        "
      >
        <svg
          style="margin-right: 10px"
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.98965 17.1069C4.32285 17.1069 4.59034 16.8394 4.59034 16.5062C4.59034 16.173 4.32379 15.9055 3.98965 15.9055C3.65552 15.9055 3.38896 16.172 3.38896 16.5062C3.38896 16.8403 3.65664 17.1069 3.98965 17.1069ZM18.4063 12.902H12.6922L16.7318 8.86237C17.2011 8.39308 17.2011 7.63283 16.7318 7.16354L13.3342 3.76587C13.0995 3.53123 12.7943 3.41391 12.4846 3.41391C12.1795 3.41391 11.87 3.53123 11.6353 3.76587L7.5938 7.80365V2.08957C7.5938 1.42806 7.05393 0.888184 6.39242 0.888184L1.58688 0.888187C0.92537 0.888187 0.385498 1.42806 0.385498 2.08957V16.5062C0.385498 18.496 1.99986 20.0765 3.98965 20.0765L18.4063 20.1103C19.0678 20.1103 19.6076 19.5705 19.6076 18.9089V14.1034C19.6076 13.4426 19.067 12.902 18.4063 12.902ZM6.39242 16.5062C6.39242 17.8296 5.31305 18.9089 3.98965 18.9089C2.66625 18.9089 1.58688 17.8296 1.58688 16.5062V11.7006H6.39242V16.5062ZM6.39242 10.4993H1.58688V6.8951H6.39242V10.4993ZM6.39242 5.69372H1.58688V2.08957H6.39242V5.69372ZM7.5938 9.50436L12.4819 4.61247L15.8796 8.01014L7.5938 16.2997V9.50436ZM18.4063 18.9089H6.68526L11.4908 14.1034H18.4063V18.9089Z"
            fill="#00B4E6"
          />
        </svg>
        Download Guidelines
      </a>

      <a
        [href]="videoUrl"
        target="_blank"
        type="button"
        class="j7 j8 an j9 ja bn fj fk fv fw fl fm am e8 b3 e6 bt bu jb jc ju je q r s ds bw cv by cx c2"
        style="
          font-size: 18px;
          border: 1px solid #00b4e6;
          color: #00b4e6;
          background-color: white;
          display: flex;
          align-items: center;
          gap: 10px;
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="icon icon-tabler icons-tabler-filled icon-tabler-brand-youtube"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path
            d="M18 3a5 5 0 0 1 5 5v8a5 5 0 0 1 -5 5h-12a5 5 0 0 1 -5 -5v-8a5 5 0 0 1 5 -5zm-9 6v6a1 1 0 0 0 1.514 .857l5 -3a1 1 0 0 0 0 -1.714l-5 -3a1 1 0 0 0 -1.514 .857z"
          />
        </svg>
        <span>Watch Guidelines Video</span>
      </a>
    </div>
  </div>

  <!-- Measurements Loop -->
  <div *ngFor="let measure of measurements; let mIndex = index">
    <div
      class="p-4"
      style="margin-bottom: 40px; background-color: white; width: 100%"
    >
      <h1 class="text-center">{{ measure.attributeOptionName }}</h1>
      <p class="text-center">{{ measure.helpText }}</p>
      <p class="text-center">All measurements should be in centimeters</p>
      <div class="row">
        <div class="col-md-8">
          <div
            [id]="'svg-container-' + measure.attributeOptionId"
            class="mt-5"
            [innerHTML]="svgContent[measure.attributeOptionId]"
            style="max-width: 100%; height: auto; text-align: center"
          ></div>
        </div>

        <div class="col-md-4">
          <div class="row">
            <!-- Left: Circumference -->
            <div class="col-6">
              <h6 hidden="text-muted mb-2">Circumference</h6>

              <ng-container
                *ngFor="let m of circumferenceList(measure); let i = index"
              >
                <div class="form-group mb-3">
                  <label style="color: #2f2f2f" [for]="m.name">{{
                    m.name
                  }}</label>
                  <input
                    type="number"
                    class="form-control measure-input"
                    [id]="m.name"
                    [disabled]="m.disabled"
                    [required]="!m.disabled"
                    f
                    [(ngModel)]="m.selectedValue"
                    (focus)="onMeasureSelected(m, measure)"
                    (input)="onInputChange($event, m, measure)"
                    (blur)="onBlur(m.name, measure.attributeOptionId)"
                    min="0"
                    pattern="\d*"
                    [attr.tabindex]="getTabIndex(mIndex, i, 'circumference')"
                  />
                </div>

                <div *ngIf="errors[m.id]" style="color: red; font-size: 12px">
                  {{ errors[m.id] }}
                </div>
              </ng-container>
            </div>

            <!-- Right: Length -->
            <div class="col-6">
              <h6 hidden class="text-muted mb-2">Length</h6>

              <ng-container
                *ngFor="let m of lengthList(measure); let i = index"
              >
                <div class="form-group mb-3">
                  <label style="color: #2f2f2f" [for]="m.name">{{
                    m.name
                  }}</label>
                  <input
                    type="number"
                    class="form-control measure-input"
                    [id]="m.name"
                    [disabled]="m.disabled"
                    [required]="!m.disabled"
                    [(ngModel)]="m.selectedValue"
                    (focus)="onMeasureSelected(m, measure)"
                    (input)="onInputChange($event, m, measure)"
                    (blur)="onBlur(m.name, measure.attributeOptionId)"
                    min="0"
                    pattern="\d*"
                    [attr.tabindex]="getTabIndex(mIndex, i, 'length')"
                  />
                </div>

                <div *ngIf="errors[m.id]" style="color: red; font-size: 12px">
                  {{ errors[m.id] }}
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Accessories Section -->
  <div style="background-color: #f8f4f4; width: 100%">
    <div
      class="p-4"
      style="margin-bottom: 40px; background-color: white; width: 100%"
    >
      <h1 class="text-center">Accessories</h1>
      <p class="text-center">Configure your accessories below.</p>
    </div>

    <!-- Loop over the accessories -->
    <div
      *ngFor="let accessory of accessories"
      class="p-4 mb-4"
      style="background-color: white; width: 100%"
    >
      <h3 class="text-center" style="margin-bottom: 5%">
        {{ accessory.accessory.accessoryName }}
      </h3>
      <div class="row">
        <!-- Left Column: SVGs -->
        <div class="col-md-6 mb-3" style="height: auto">
          <div class="d-flex flex-wrap justify-content-center">
            <!-- Loop over accessory's attributes to display SVGs -->

            <div *ngFor="let attribute of accessory.accessory.attributes">
               <!-- <pre>{{ attribute | json }} </pre> -->
              <ng-container
                *ngIf="
                  attribute.componentType === 'Select' &&
                  getSelectedValueText(attribute)
                "
              >

                <div
                
                  *ngIf="
                    svgContent[attribute.guid] &&
                    svgContent[attribute.guid].toString().includes('<svg')
                    
                  "
                  class="svg-item"
                  style="
                    width: 100%;
                    max-width: 400px;
                    min-height: 320px;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  <div
                    [innerHTML]="svgContent[attribute.guid]"
                    class="svg-container"
                  ></div>
                  <div style="color: red; min-height: 24px; margin-top: 5px">
                    <ng-container
                      *ngIf="showInvalidPositionMessage[attribute.guid]"
                    >
                      Please select a valid position for your accessory.
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- Right Column: Attributes -->
        <div class="col-md-6">
          <!-- Loop over the attributes of each accessory -->
          <div class="row">
            <div
              *ngFor="let attribute of accessory.accessory.attributes"
              class="col-8 mb-3"
              [hidden]="attribute.isHidden"
            >
              <div class="form-group">
                <label
                  style="color: #2f2f2f"
                  [attr.for]="attribute.guid + '_select'"
                >
                  {{ attribute.name }}
                </label>

                <!-- Render the component based on its type -->
                <ng-container [ngSwitch]="attribute.componentType">
                  <!-- Select Dropdown with SVG -->
                  <div
                    *ngSwitchCase="'Select'"
                    class="d-flex align-items-center"
                  >
                 
                    <!-- Select Dropdown -->
                    <select
                      class="form-control custom-select flex-grow-1"
                      [id]="attribute.guid + '_select'"
                      [value]="selectedValues[attribute.guid] || ''"
                      (change)="onAttributeChange(attribute.guid, $event)"
                    >
                      <option value="">Select View</option>
                      <option
                        *ngFor="let value of attribute.values"
                        [value]="value.id"
                        [selected]="selectedValues[attribute.guid] === value.id"
                      >
                        {{ value.value }}
                      </option>
                    </select>
                  </div>

                  <!-- Radio Button -->
                  <div *ngSwitchCase="'RadioButton'">
                    <div class="d-flex flex-column mt-2">
                      <div *ngFor="let value of attribute.values" class="mr-3">
                        <label class="custom-option">
                          <input
                            type="radio"
                            [id]="attribute.guid + '_radio_' + value.id"
                            [name]="attribute.guid"
                            [value]="value.id"
                            [checked]="
                              selectedValues[attribute.guid] === value.id
                            "
                            (change)="onAttributeChange(attribute.guid, $event)"
                          />
                          <span>{{ value.value }}</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <!-- CheckBox Case -->
                  <div *ngSwitchCase="'CheckBox'">
                    <div class="d-flex flex-column mt-2">
                      <div *ngFor="let value of attribute.values" class="mr-3">
                        <label class="custom-option">
                          <input
                            type="checkbox"
                            [id]="attribute.guid + '_checkbox_' + value.id"
                            [name]="attribute.guid"
                            [value]="value.id"
                            [checked]="
                              selectedValues[attribute.guid] === value.id
                            "
                            (change)="onAttributeChange(attribute.guid, $event)"
                          />
                          <span>{{ value.value }}</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <!-- Text Input -->
                  <input
                    *ngSwitchCase="'Text'"
                    type="text"
                    class="form-control"
                    [id]="attribute.guid + '_input'"
                    [(ngModel)]="attribute.value"
                    (input)="onAttributeChange(attribute.guid, $event)"
                    [disabled]="!attribute.isEnable"
                  />

                  <!-- Default Case -->
                  <div *ngSwitchDefault>
                    Unsupported component type: {{ attribute.componentType }}
                  </div>
                </ng-container>

                <!-- Display validation error if any -->
                <div *ngIf="errors[attribute.guid]" class="text-danger mt-1">
                  {{ errors[attribute.guid] }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
